/**
 * Copyright © Veeam Software Group GmbH.
 */

import { SystemTypeRepresentation } from '@veeam-vspc/models/web-controllers';

export type SystemTypeRepresentations = SystemTypeRepresentation;
export const SystemTypeRepresentations = SystemTypeRepresentation;
